import * as React from 'react';

export const getPdfTrackingParams = (source = '') => ({
  utm_source: source,
  utm_medium: 'pdf',
  utm_campaign: 'PDF',
});

/** Hook util to support dependency injection **/
interface PDFSourceContextProps {
  source: string;
}

export const PDFSourceContext = React.createContext<PDFSourceContextProps>({ source: '' });
export const usePDFSourceContext = () => React.useContext(PDFSourceContext);
export const usePdfTrackingParams = () => {
  const { source } = usePDFSourceContext();
  return getPdfTrackingParams(source); // too simple to use memo
};
